/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import SwalToast from '../components/Common/SwalToast';
import { API_ENDPOINTS } from '../const/ApiEndpoints';
import { store } from '../state/store/Store';
import { getCookieValue } from './Api';

const logout = () => {
  try {
    localStorage.clear();
    window.KEYCLOAK_CONFIG.logout();
  } catch (e) {
    console.log(e);
  }
};
function containInApiList(targetString) {
  const endpointValues = Object.values(API_ENDPOINTS);
  return endpointValues?.some((endpoint) => targetString?.includes(endpoint));
}
let isLoggingOut = false;
const delayedLogout = () => {
  if (!isLoggingOut) {
    isLoggingOut = true;
    setTimeout(() => {
      logout();
    }, 2000); // Give user 2 seconds to read the popup
  }
};

export const initializeAxiosForKeycloak = () => {
  let headersCommonOptions = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  let showLoaderEvent = new Event('showLoader', { bubbles: true });
  let hideLoaderEvent = new Event('hideLoader', { bubbles: true });
  let numberOfApiCallsPending = 0;
  axios.defaults.baseURL = API_ENDPOINTS.DJANGO_SERVER_ADDRESS;
  axios.defaults.headers.common = headersCommonOptions;
  axios.interceptors.request.use((req) => {
    // `req` is the Axios request config, so you can modify
    // the `headers`.

    const authState = store.getState().app.auth;
    const token = authState?.token;
    const org = authState?.org;

    const csrfToken = getCookieValue('csrftoken');
    if (['post', 'put', 'patch', 'delete'].includes(req.method)) {
      req.headers['X-CSRFToken'] = csrfToken;
    }
    if (token && !req.url.startsWith('https://')) {
      req.headers.Authorization = `Bearer ${token}`;
    }
    if (org) {
      req.headers.org = org;
    }
    numberOfApiCallsPending++;
    if (req?.loader == false || req?.data?.loader == false) {
      document.dispatchEvent(hideLoaderEvent);
    } else {
      document.dispatchEvent(showLoaderEvent);
    }
    return req;
  });

  axios.interceptors.response.use(
    (response) => {
      numberOfApiCallsPending--;
      if (numberOfApiCallsPending === 0) {
        setTimeout(() => {
          document.dispatchEvent(hideLoaderEvent);
        }, 400);
      }
      return response;
    },
    async (error) => {
      numberOfApiCallsPending--;
      if (numberOfApiCallsPending === 0) {
        setTimeout(() => {
          document.dispatchEvent(hideLoaderEvent);
        }, 400);
      }
      const errorMessage = error?.response?.data?.Msg
        ? typeof error?.response?.data?.Msg === 'string'
          ? error.response.data.Msg
          : JSON.stringify(error.response.data.Msg)
        : error.message;

      if (
        [401, 403].includes(error.response?.status) &&
        !error?.config?._retry &&
        containInApiList(error?.config?.url)
      ) {
        error.config._retry = true;

        try {
          if (window.KEYCLOAK_CONFIG.isTokenExpired()) {
            console.log('Token expired. Trying to refresh...');

            const authState = store.getState().app.auth;
            try {
              await window.KEYCLOAK_CONFIG.updateToken(2);
              const newToken = window.KEYCLOAK_CONFIG.token;

              if (newToken) {
                store.dispatch({
                  type: 'app/setAuth',
                  payload: { ...authState, token: newToken },
                });
                axios.defaults.headers.common.Authorization = `Bearer ${newToken}`;
                error.config.headers.Authorization = `Bearer ${newToken}`;
                return axios.request(error.config);
              }
            } catch (refreshError) {
              // Refresh token itself is no longer valid - session has genuinely expired
              SwalToast({
                icon: 'warning',
                title:
                  'Your session has expired. Please log in to continue using our services.',
              });
              store.dispatch({
                type: 'app/setAuth',
                payload: {},
              });
              store.dispatch({
                type: 'app/setPanelNavigation',
                payload: { panelNavigation: '' },
              });
              delayedLogout();
              return Promise.reject(error);
            }
          } else {
            // Server rejected a token the client still considers valid
            if (error.response?.data?.Msg) {
              SwalToast({
                icon: 'error',
                title: errorMessage,
              });
            } else {
              // most likely the session was ended/replaced elsewhere
              SwalToast({
                icon: 'warning',
                title:
                  'Your session has ended because you logged in from another device or location.',
              });
            }
            delayedLogout();
            return Promise.reject(error);
          }

          return Promise.reject(error);
        } catch (tokenRefreshError) {
          delayedLogout(); // Ensuring logout happens on error
          return Promise.reject(error);
        }
      }

      if (error.response?.data?.Msg) {
        SwalToast({
          icon: 'error',
          title: errorMessage,
        });
      }
      return Promise.reject(error);
    }
  );
};

// export default intializeAxiosForKeycloak;
